<div class="tooltip-sm-temp" (clickOutside)="doClose()">
    <div class="px-8">
        <p class="text-l">
            {{ (isRepayable ? 'dev.myAccount.orders.tooltip.repayable' : 'dev.suborders.tooltip') | translate: { $0: subOrdersLength } }}
        </p>
    </div>
    <div class="close-temp">
        <svg-icon src="close-s" (click)="doClose()"></svg-icon>
    </div>
</div>
